import { render, staticRenderFns } from "./Cadastros.vue?vue&type=template&id=d54d7972"
import script from "./Cadastros.vue?vue&type=script&lang=ts"
export * from "./Cadastros.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports